//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import getApiDataByContext from '~/utils/getApiDataByContext';
import { errorComponent, headerComponent, contentWrapper } from '@tidal/microservice-components';
import isInternetExplorerMixin from '~/mixins/isInternetExplorerMixin';
import tidalFooter from '@tidal/styles-footer';
import languageSwitcher from '@tidal/language-switcher';
import tidalButton from '@tidal/styles-button';
import { tidalInput } from '@tidal/styles-form';
import recaptchaComponent from '~/components/recaptchaComponent.vue';
import pathSelector from '~/utils/pathSelector';

export default {
    components: {
        contentWrapper,
        headerComponent,
        errorComponent,
        tidalFooter,
        languageSwitcher,
        tidalButton,
        tidalInput,
        recaptchaComponent,
    },
    mixins: [isInternetExplorerMixin],
    asyncData: getApiDataByContext,
    data() {
        return {
            /** @type {import('@tidal/user-middleware').AppMode | null} */
            appMode: null,
            loading: false,
            /** @type {Record<string, any> | null} */
            error: null,
            /** @type {Record<string, any> | null} */
            langObject: null,
            email: '',
            langPicked: '',
            /** @type {Array<string> | null} */
            availableLangs: null,
            recaptchaKeyV3: '',
            noAccountRedirectUrl: '',
            user: null,
            title: '',
            subtitle: '',
            recaptchaKey: 'disabled',
            /** @type {string | undefined} */
            recaptchaResponse: '',
            form: {
                valid: false,
                email: {
                    error: false,
                    valid: false,
                },
            },
            resetSuccess: false,
            /** @type {boolean | {communicationChannel: string}} */
            requestSuccess: false,
        };
    },
    computed: {
        /** @returns {Record<string, any>} */
        lang() {
            return pathSelector(this.langObject || {});
        },
    },
    watch: {
        email: function() {
            this.validateEmail();
        },
    },
    beforeMount() {
        this.title = this.lang.resetpassword.header.request.title;
        this.subtitle = this.lang.resetpassword.header.request.subtitle;
        this.validateEmail();
    },
    mounted() {
        // check if recaptcha is fully loaded on the page
        // @ts-ignore
        if (this.recaptchaKey !== 'disabled') {
            // @ts-ignore
            this.$refs.recap.renderRecap();
            this.loading = false;
        }
    },
    methods: {
        hideError() {
            this.error = null;
        },
        validateEmail() {
            this.form.valid = this.email.length > 1;
        },
        submitForm() {
            //block form submition on double/triple click
            if (this.loading) {
                return;
            }
            this.loading = true;
            if (this.recaptchaKey !== 'disabled') {
                // @ts-ignore
                this.$refs.recap.execute();
                // stop loading in case user clicks out of the recaptcha and dissmiss it
                this.loading = false;
            } else {
                this.requestReset(this.email);
            }
        },
        /** @param {string} email */
        requestReset(email) {
            const data = {
                username: email,
                recaptchaResponse: this.recaptchaResponse,
            };
            if (this.form.valid) {
                this.loading = true;
                this.$axios.post('/api/resetpass', data).then(res => {
                    this.title = this.lang.resetpassword.header.request.success.title;
                    if (res.data.communicationChannel && res.data.communicationChannel.toUpperCase() === 'EMAIL') {
                        this.subtitle = this.lang.resetpassword.header.request.success.subtitle;
                    } else {
                        this.subtitle = this.lang.resetpassword.header.request.successphone.subtitle;
                    }
                    this.requestSuccess = res.data;
                }).catch(() => {
                    // we shouldn't show the error we should always continue
                    this.title = this.lang.resetpassword.header.request.success.title;
                    this.subtitle = this.lang.resetpassword.header.request.success.subtitle;
                    this.requestSuccess = {
                        communicationChannel: 'EMAIL',
                    };
                }).then(() => {
                    this.loading = false;
                    if (this.$refs.recap) {
                        // @ts-ignore
                        this.$refs.recap.reset();
                    }
                });
            }
        },
        /** @param {Record<string, any> | null} errorObj */
        setError(errorObj) {
            if (errorObj) {
                errorObj.message = this.lang.error.generic.message;
            }

            this.error = errorObj;
        },
        /** @param {string} recap */
        recapVerified(recap) {
            this.recaptchaResponse = recap;
            this.requestReset(this.email);
        },
        recapExpired() {
            this.recaptchaResponse = undefined;
            this.form.valid = false;
        },
    },
};
